import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <ul className="main-fbtn">
        <li className="left"><a href="/experience/inquiry">전화 상담 신청</a></li>
        <li className="right"><a href="/experience/request">무료 체험 신청</a></li>
      </ul>
    )
  }
}

export default Footer;